import Vue from '/vodalys/vvuejs/vue.js';

import { debug } from "/vodalys/.jslibs";
const log = debug('translate25:plugin');


const parentVueAppFromDom = (el) => {
    if (!el) {
        return undefined
    }
    if (el.__vue__) {
        return el.__vue__
    }
    return parentVueAppFromDom(el.parentElement)
}

function translate25VueAppHook(ctx: Vue) {

    // console.warn('translate25VueAppHook', ctx, ctx.ngContext().$attrs.name, ctx.ngContext().$attrs.translate25Context)

    const ng$attrs = ctx.ngContext().$attrs
    const ng$element = ctx.ngContext().$element


    // console.warn('ng$attrs', ng$attrs)
    // console.warn('ng$element', ng$element)

    const parentVue = parentVueAppFromDom(ng$element[0])

    // console.warn('parentVue', parentVue)

    const attrName = ng$attrs.name
    const attrTranslate25Context = ng$attrs.translate25Context?.split('|') ?? []

    let translate25Context = [];
    if (!parentVue) {
        translate25Context = ['root', attrName, ...attrTranslate25Context]
    // console.error('translate25Context', translate25Context)
    }
    else {
        translate25Context = [...parentVue.$i18nContexts, attrName, ...attrTranslate25Context]
    }

    // filter out undefined values
    translate25Context = translate25Context.filter(Boolean)

    return {
        translate25Context
    }
}

export default {
    install(Vue: Vue): void {

        // log('installing plugin', this)


        Vue.prototype.$_vte = function keyExists(key: string): boolean {
            const [base] = this.$i18n.locale.split('-')
            const fallback = [].concat(this.$i18n.fallbackLocale || [])

            const locales = [this.$i18n.locale, base, ...fallback]

            return locales.some(loc => this.$te(key, loc))
        }


        Vue.prototype.$vt = function (key, values): string {
            const i18nContexts = this.$i18nContexts ?? []

            const context = i18nContexts.find(context => this.$_vte(`${context}.${key}`))

            if (context) {
                return this.$t(`${context}.${key}`, values)
            }
            else {
                return this.$t(key, values)
            }
        }

        Vue.prototype.$vtc = function (key, values): string {
            const i18nContexts = this.$i18nContexts ?? []

            const context = i18nContexts.find(context => this.$_vte(`${context}.${key}`))

            if (context) {
                return this.$tc(`${context}.${key}`, values)
            }
            else {
                return this.$tc(key, values)
            }
        }

        Vue.prototype.$vn = function (key, values): string {
            const i18nContexts = this.$i18nContexts ?? []

            const context = i18nContexts.find(context => this.$_vte(`${context}.${key}`))

            if (context) {
                return this.$n(`${context}.${key}`, values)
            }
            else {
                return this.$n(key, values)
            }
        }

        Vue.mixin({
            data() {
                return {
                    _translate25Context: undefined
                }
            },
            props: {
                translate25Context: {
                    type: [String, Array]
                }
            },
            mounted() {
                const isRootInstance = this.$options === this.$root.$options;
                if (isRootInstance) {
                    const { translate25Context } = translate25VueAppHook(this)
                    this.$data._translate25Context = translate25Context
                }
                else {
                }



            },
            computed: {
                $i18nContexts(): string[] {
                    const contexts: string[] = [];

                    if (this?.$options?.translate25Context) {
                        // log('Using context from $options.translate25Context:', this.$options.translate25Context);
                        if (Array.isArray(this.$options.translate25Context)) {
                            contexts.push(...this.$options.translate25Context);
                        } else {
                            contexts.push(this.$options.translate25Context);
                        }
                    }
                    if (this.$data._translate25Context) {
                        // log('Using context from $data._translate25Context:', this.$data._translate25Context);
                        if (Array.isArray(this.$data._translate25Context)) {
                            contexts.push(...this.$data._translate25Context);
                        } else {
                            contexts.push(this.$data._translate25Context);
                        }
                    }
                    if (this.translate25Context) {
                        log('Using context from translate25Context prop:', this.translate25Context);

                        if (Array.isArray(this.translate25Context)) {
                            contexts.push(...this.translate25Context);
                        } else {
                            contexts.push(this.translate25Context);
                        }
                    }
                    if (this.component && this.component.translate25Context) {
                        // log('Using context from component.$translate25Context:', this.component.translate25Context);
                        if (Array.isArray(this.component.translate25Context)) {
                            contexts.push(...this.component.translate25Context);
                        } else {
                            contexts.push(this.component.translate25Context);
                        }
                    }
                    if (this.instance && this.instance.$translate25Context) {
                        // log('Using context from instance.$translate25Context:', this.instance.$translate25Context);
                        if (Array.isArray(this.instance.$translate25Context)) {
                            contexts.push(...this.instance.$translate25Context);
                        } else {
                            contexts.push(this.instance.$translate25Context);
                        }
                    }
                    if (this.$parent && this.$parent.$i18nContexts) {
                        // log('Using context from $parent.$i18nContexts:', this.$parent.$i18nContexts);
                        if (Array.isArray(this.$parent.$i18nContexts)) {
                            contexts.push(...this.$parent.$i18nContexts);
                        } else {
                            contexts.push(this.$parent.$i18nContexts);
                        }
                    }
                    if (this.$parent && this.$parent.$data._translate25Context) {

                        // console.error('Using context from $parent.$data._translate25Context', this.$parent.$data._translate25Context);
                        if (Array.isArray(this.$parent.$data._translate25Context)) {
                            contexts.push(...this.$parent.$data._translate25Context);
                        } else {
                            contexts.push(this.$parent.$data._translate25Context);
                        }
                    }

                    if (contexts.length === 0) {
                        // log('No context found, defaulting to "root"');
                        contexts.push('root');
                    }
                    const uniqueContexts = Array.from(new Set(contexts));
                    // log('Unique contexts:', uniqueContexts);
                    uniqueContexts.sort((a, b) => {
                        const segmentsA = a.split(/[._-]+/);
                        const segmentsB = b.split(/[._-]+/);
                        if (segmentsA.length !== segmentsB.length) {
                            return segmentsB.length - segmentsA.length;
                        }
                        return a.localeCompare(b);
                    });
                    // log('Sorted unique contexts:', uniqueContexts);
                    return uniqueContexts;
                }
            },
            created() {
            }
        });
    }
}